import { render, staticRenderFns } from "./popoverSelectData.vue?vue&type=template&id=96cad10a&scoped=true"
import script from "./popoverSelectData.vue?vue&type=script&lang=js"
export * from "./popoverSelectData.vue?vue&type=script&lang=js"
import style0 from "./popoverSelectData.vue?vue&type=style&index=0&id=96cad10a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96cad10a",
  null
  
)

export default component.exports